import { render, staticRenderFns } from "./NuxtLinkExtra.vue?vue&type=template&id=5d822bb8&"
import script from "./NuxtLinkExtra.vue?vue&type=script&lang=js&"
export * from "./NuxtLinkExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports